import { action as apiAction } from 'api/Api'
import { optimisticDispatch } from 'utils/sagas'
import {
  remove as removeDocumentTemplateSource
} from '../redux/documentTemplateSources'
import sweetalert from 'sweetalert2'

type Payload = {
  id: number
}

const requestRemoveDocumentTemplateSource = (payload: Payload) => async (dispatch, getState) => {
  const { id } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeDocumentTemplateSource({
    id,
  }))

  try {
    await apiAction('RemoveDocumentTemplateSource', {
      id,
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 512) {
      try {
        const state = getState()

        await sweetalert({
          text: state.kanbo.locale.messages['DOCUMENT_TEMPLATE_SOURCES_REMOVE_IN_USE_ERROR'],
          type: 'error'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}

export default requestRemoveDocumentTemplateSource